import React from 'react';
import { Card, Statistic, Progress, Row, Col, Typography } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface StatItem {
  title: string;
  value: number | string;
  precision?: number;
  prefix?: React.ReactNode;
  suffix?: string;
}

interface ProgressItem {
  title: string;
  percent: number;
  status?: 'success' | 'exception' | 'normal' | 'active';
}

interface ClientStatsCardProps {
  title: string;
  stats?: StatItem[];
  progress?: ProgressItem[];
  loading?: boolean;
}

const ClientStatsCard: React.FC<ClientStatsCardProps> = ({
  title,
  stats = [],
  progress = [],
  loading = false
}) => {
  return (
    <Card title={title} loading={loading}>
      {stats.length > 0 && (
        <Row gutter={16} style={{ marginBottom: 16 }}>
          {stats.map((stat, index) => (
            <Col span={12} key={index}>
              <Statistic
                title={stat.title}
                value={stat.value}
                precision={stat.precision}
                prefix={stat.prefix}
                suffix={stat.suffix}
              />
            </Col>
          ))}
        </Row>
      )}
      
      {progress.length > 0 && (
        <div>
          {progress.map((item, index) => (
            <div key={index} style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}>
                <Typography.Text>{item.title}</Typography.Text>
              </div>
              <Progress 
                percent={item.percent} 
                status={item.status}
                strokeColor={
                  item.status === 'success' ? '#52c41a' :
                  item.status === 'exception' ? '#f5222d' :
                  '#1890ff'
                }
              />
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default ClientStatsCard; 